export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_grey_p.e622d621.jpg";